module.exports = __webpack_public_path__ + "img/img_power_retail@3x.a6592a04.png";